import { render } from "./PointsManager.vue?vue&type=template&id=e90d5f32&scoped=true"
import script from "./PointsManager.vue?vue&type=script&lang=js"
export * from "./PointsManager.vue?vue&type=script&lang=js"

import "./PointsManager.vue?vue&type=style&index=0&id=e90d5f32&scoped=true&lang=css"

import exportComponent from "../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e90d5f32"]])

export default __exports__